import {
  EventsFutureHomeState,
  EventActionTypes,
  //FETCH_EVENTS_FUTURE,
  FETCH_EVENTS_FUTURE_FULFILLED,
  FETCH_EVENTS_FUTURE_PENDING,
  FETCH_EVENTS_FUTURE_REJECTED,
  SET_EVENTS_FUTURE_PAGE_SIZE,
  SET_EVENTS_FUTURE_PAGE,
} from './types';
import { paginationInitialState } from '../../Pagination/reducer';
import { filterInitialState } from '../../Filter/reducer';
import { AnyAction } from 'redux';

const initialState = {
  items: [],
  fetching: false,
  fetched: false,
  error: null,
  nbResult: 0,
  page: 1,
  pageSize: 8,
};

export const EventsFutureReducer = (
  state: EventsFutureHomeState = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_EVENTS_FUTURE_PAGE_SIZE:
      return { ...state, pageSize: action.payload };
    case SET_EVENTS_FUTURE_PAGE:
      return { ...state, page: action.payload };
    case FETCH_EVENTS_FUTURE_PENDING: {
      return {
        ...state,
        fetched: false,
        fetching: true,
        items: state.page === 1 ? [] : state.items,
      };
    }
    case FETCH_EVENTS_FUTURE_FULFILLED: {
      const { data, nbResult } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items:
          state.page === 1
            ? data[0] ?? []
            : [...state.items, ...(data[0] ?? [])],
        nbResult: nbResult,
      };
    }
    case FETCH_EVENTS_FUTURE_REJECTED: {
      let error = action.payload;
      switch (error?.response?.status) {
        case 404:
          error = {
            title: error?.response?.data?.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0,
      };
    }
    default:
      return state;
  }
};

export default EventsFutureReducer;
